import React from "react";

import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import { useTranslation, Trans } from "react-i18next";

import {
  ModalContainer,
  Header,
  DangerIcon,
  TitleText,
  Content,
  Footer,
  StyledButtonLogout,
  StyledButtonStayLogIn,
} from "./styles";

const DANGER_ICON = require("../../../assets/img/outlineDanger.svg");

interface ModalProps {
  open: boolean;
  onClose: () => void;
  loggedOut: () => void;
  stayLoggedIn: () => void;
}

const ModalSessionComponent: React.FC<ModalProps> = ({
  open,
  onClose,
  loggedOut,
  stayLoggedIn,
}) => {
  const { t: translate } = useTranslation();

  return (
    <Modal open={open}>
      <ModalContainer>
        <Header>
          <DangerIcon src={DANGER_ICON} alt="Danger Icon" />
          &nbsp;&nbsp;&nbsp;
          <TitleText>{translate("yourSessionIsAboutToExpire")}</TitleText>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Header>
        <Content>
          <Trans i18nKey="autoTerminateSessionExpire" components={{ strong: <strong /> }} />
        </Content>
        <Footer>
          <StyledButtonLogout variant="text" onClick={() => loggedOut()}>
            {translate("logOut")}
          </StyledButtonLogout>
          <StyledButtonStayLogIn onClick={() => stayLoggedIn()}>
            {translate("stayLoggedIn")}
          </StyledButtonStayLogIn>
        </Footer>
      </ModalContainer>
    </Modal>
  );
};

export default ModalSessionComponent;
